import styled from 'styled-components';

const DashedDashboardLine = styled.div`
    box-sizing: border-box;
    width: 100%;
    height: 2px;
    border-bottom: 1px solid ${props => props.theme.colors.lightgray};
`;

export default DashedDashboardLine;



// WEBPACK FOOTER //
// ./src/components/atoms/DividerLine.js